import React from 'react';
import Card from '../../../../core/layout/Card';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import LearningCorrectAnswersRateTableContainer from './LearningCorrectAnswersRateTableContainer';
import LearningReachedLevelRateTableContainer from './LearningReachedLevelRateTableContainer';

const LearningCourseTab = () => (
  <div>
    <Card>
      <Row>
        <Column size={6}>
          <LearningCorrectAnswersRateTableContainer />
        </Column>
        <Column size={6}>
          <LearningReachedLevelRateTableContainer />
        </Column>
      </Row>
    </Card>
  </div>
);

export default LearningCourseTab;
